import { useState } from 'react';
import { validateEmail } from '../../utils/validation';
import api from '../../utils/api';
import './NewsletterSignup.css';

function NewsletterSignup({ variant = 'default' }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      const response = await api.post('/newsletter', { email });
      setMessage(response.data.message);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div className={`newsletter newsletter--${variant}`}>
        <p className="newsletter__success">{message}</p>
      </div>
    );
  }

  return (
    <div className={`newsletter newsletter--${variant}`}>
      <h3 className="newsletter__title">Stay Updated</h3>
      <p className="newsletter__text">Subscribe to our newsletter for exclusive offers and events.</p>
      <form className="newsletter__form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="newsletter__input"
          required
        />
        <button type="submit" className="newsletter__btn">Subscribe</button>
      </form>
      {error && <p className="newsletter__error">{error}</p>}
    </div>
  );
}

export default NewsletterSignup;
